;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

/**
 * Generates the array of Dayjs objects that form the schedule timeline
 * (ultimately displayed as e.g. 7:00 PM, 7:30 PM, 8:00 PM, 8:30 PM...)
 * @param {Dayjs} now - right now. this is a param so that we can override it.
 * @param {string} primaryTimezone - should be in IANA format, as passed by CS
 * @param {string} scheduleDate - the date for which to generate the schedule, in YYYY-MM-DD format
 * @returns {dayjs.Dayjs[]} - array of Dayjs objects representing the schedule times
*/
export const getScheduleTimes = (
  now: Dayjs,
  primaryTimezone: string,
  scheduleDate: string,
): dayjs.Dayjs[] => {
  const today = now.format('YYYY-MM-DD');

  const scheduleDateIsToday = scheduleDate === today;

  let numberOfTimesToGenerate = 48; // each hour gets split into two half-hour segments
  let firstScheduleTime = dayjs.tz(`${scheduleDate} 00:00`, primaryTimezone); // default to midnight of the schedule date

  if (scheduleDateIsToday) {
    const hour = now.hour(); // current hour
    const minutes = now.minute(); // current minutes past the hour

    // however many half hour segments are left in today
    numberOfTimesToGenerate = (24 * 2) - (hour * 2) - (minutes >= 30 ? 1 : 0);

    firstScheduleTime =
      minutes >= 30
        ? dayjs.tz(now.minute(30), primaryTimezone)
        : dayjs.tz(now.minute(0), primaryTimezone); // start time should be last full half-hour
  }

  const scheduleTimes = [firstScheduleTime];

  // generate schedule times for the remaining number of half-hour segments
  // (numberOfTimesToGenerate - 1) because we have already generated firstScheduleTime
  for (let index = 0; index < numberOfTimesToGenerate - 1; index++) {
    // add a half hour to previous time in array to get new time to add
    const newTime = scheduleTimes[index].add(30, 'minute');
    scheduleTimes.push(newTime);
  }

  return scheduleTimes;
};
